import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { TICKER_SYMBOLS as DEFAULT_SYMBOLS } from "@/data/site";
import api from "@/lib/api";

export default function MarketTicker() {
  const [symbols, setSymbols] = useState(DEFAULT_SYMBOLS);

  useEffect(() => {
    let cancelled = false;
    api.get("/content")
      .then(({ data }) => {
        if (cancelled) return;
        const arr = data?.ticker_symbols;
        if (Array.isArray(arr) && arr.length >= 4) setSymbols(arr);
      })
      .catch(() => { /* keep defaults */ });
    return () => { cancelled = true; };
  }, []);

  return (
    <div
      data-testid="market-ticker"
      className="relative border-y"
      style={{
        borderColor: "color-mix(in srgb, var(--brand) 8%, transparent)",
        background: "linear-gradient(180deg, color-mix(in srgb, var(--brand) 1.5%, transparent), transparent)",
      }}
    >
      <div
        className="max-w-7xl mx-auto px-5 lg:px-8 overflow-hidden"
        style={{
          WebkitMaskImage:
            "linear-gradient(90deg, transparent 0, #000 64px, #000 calc(100% - 64px), transparent 100%)",
          maskImage:
            "linear-gradient(90deg, transparent 0, #000 64px, #000 calc(100% - 64px), transparent 100%)",
        }}
      >
        <Marquee
          gradient={false}
          speed={42}
          pauseOnHover
          autoFill
        >
        {symbols.map((t, i) => {
          const up = t.change >= 0;
          const isCrypto = /BTC|ETH|SOL|XRP|DOGE|ADA/.test(t.symbol);
          const decimals = isCrypto ? 2 : (t.symbol.includes("JPY") ? 3 : 5);
          return (
            <div
              key={`${t.symbol}-${i}`}
              data-testid={`ticker-item-${i}`}
              className="inline-flex items-center gap-3 px-6 py-3 text-xs tracking-wider"
            >
              <span className="text-[color:var(--text-2)] font-medium tabular-nums">{t.symbol}</span>
              <span className="text-[color:var(--text-1)] tabular-nums">{Number(t.price).toFixed(decimals)}</span>
              <span className={`inline-flex items-center gap-0.5 tabular-nums ${up ? "text-emerald-400" : "text-rose-400"}`}>
                {up ? <ArrowUpRight size={11} /> : <ArrowDownRight size={11} />}
                {up ? "+" : ""}{Number(t.change).toFixed(2)}%
              </span>
              <span className="w-1 h-1 rounded-full bg-[color:var(--line-strong)] mx-1" />
            </div>
          );
        })}
        </Marquee>
      </div>
    </div>
  );
}
